import { useCallback, useEffect, useState } from 'react';
import { displayError } from '../../helpers';
import { getCheckOutForCHeckIn } from '../../services/CheckOutServices';
import ReactTablePopUpSubmitWrapper from '../../components/ReactTablePopUpSubmitWrapper';
import { PENDING_CHECKIN_COLUMNS, mapPendingCheckInRow } from './pendingCheckInUtils';

function PendingCheckInModal({ open, onClose, cookies, onSelect }) {
  const [loading, setLoading] = useState(false);
  const [records, setRecords] = useState([]);

  const loadPending = useCallback(() => {
    if (!open || !cookies?.myToken) return;
    setLoading(true);
    getCheckOutForCHeckIn(cookies)
      .then((response) => {
        setRecords((response?.checkout_list || []).map(mapPendingCheckInRow));
      })
      .catch((error) => {
        displayError(error?.response?.data ?? error?.message, 'Failed to load pending check-ins');
        setRecords([]);
      })
      .finally(() => setLoading(false));
  }, [cookies, open]);

  useEffect(() => {
    loadPending();
  }, [loadPending]);

  useEffect(() => {
    if (!open || typeof document === 'undefined') return undefined;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [open]);

  if (!open) return null;

  const handleRowSubmit = (rowId) => {
    const row = records.find((item) => String(item.id) === String(rowId));
    if (!row) return;
    onSelect?.(row);
  };

  return (
    <div className="modal" tabIndex="-1" style={{ display: 'block' }}>
      <div className="modal-dialog modal-xl" style={{ height: '520px' }}>
        <div className="modal-content">
          <div className="modal-body display">
            <div className="container item-list-table-container">
              <ReactTablePopUpSubmitWrapper
                title="Pending Check-in"
                columns={PENDING_CHECKIN_COLUMNS}
                data={records}
                onRowSubmit={handleRowSubmit}
                onClose={onClose}
                isLoading={loading}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PendingCheckInModal;
